import React from "react";
import styled from "styled-components";

import bannerImage from "../../asset/banner.png";

const BannerStyle = styled.div`
    height: 540px;
    padding-top: 60px;
    background-image: url(${bannerImage});
`;

export const Banner = ({ children }) =>
    <BannerStyle>
        {children}
    </BannerStyle>;